module.exports = __webpack_public_path__ + "img/bathroom.f2c09d73.svg";